import { select, call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../helpers'
import ReservationEndpoint from '../persistence/ReservationEndpoint'
import { reduxFetch } from '../http/reduxFetch'

const refund = { ...defineTypes('REFUND')  }
const cancelDeposit = { ...defineTypes('CANCEL_DEPOSIT')  }

export const initialState = {
  loading: false,
  loaded: false,
}

export const actions = {
  refund (charge_id) {
    return { type: refund.REQUEST, charge_id: charge_id }
  },
  cancel (deposit_id) {
    return { type: cancelDeposit.REQUEST, deposit_id: deposit_id }
  },
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case refund.REQUEST:
      return { ...state, query: action.query, started: true, loading: true }
    case refund.FAILURE:
      return { ...state, loading: false, error: action.error }
    case refund.SUCCESS:
      return { ...state, loading: false, order: action.order, loaded: true, created: true }
    case cancelDeposit.REQUEST:
      return { ...state, query: action.query, started: true, loading: true }
    case cancelDeposit.FAILURE:
      return { ...state, loading: false, error: action.error }
    case cancelDeposit.SUCCESS:
      return { ...state, loading: false, order: action.order, loaded: true, created: true }
    default:
      return state
  }
}
export const selectors = {
}
export function * cancelDepositSaga (action) {
  try {
    let form = {}
    form['deposit_id'] = action.deposit_id
    let response = yield call(reduxFetch, ReservationEndpoint.cancel_deposit(form))
    if (response['data']) {
      yield put({ type: refund.SUCCESS, order: response.data })
    } else {
      yield put({ type: refund.FAILURE, response })
    }
  } catch (error) {
    yield put({ type: refund.FAILURE, error })
  }
}

export function * refundSaga (action) {
  try {
    let form = {}
    form['charge_id'] = action.charge_id
    let response = yield call(reduxFetch, ReservationEndpoint.refund(form))
    if (response['data']) {
      yield put({ type: refund.SUCCESS, order: response.data })
    } else {
      yield put({ type: refund.FAILURE, response })
    }
  } catch (error) {
    yield put({ type: refund.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest(refund.REQUEST, refundSaga)
  yield takeLatest(cancelDeposit.REQUEST, cancelDepositSaga)
}




// WEBPACK FOOTER //
// ./src/sagas/refund.js